import { t } from 'i18next'

import { DealPosition } from '@enechain/eposition-proto/bfftypes/v1/deal_pb'
import { DeliveryType } from '@enechain/eposition-proto/types/v1/deal_pb'

export const DEAL_DELIVERY_TYPE = {
  UNSPECIFIED: '',
  BG_BG: 'BG_BG',
  JEPX_JEPX: 'JEPX_JEPX',
  JEPX_BG: 'JEPX_BG',
  EEX_BG: 'EEX_BG',
  BG_EEX: 'BG_EEX',
  EEX_JEPX: 'EEX_JEPX',
  JEPX_EEX: 'JEPX_EEX',
}

export function convertDeliveryTypeLabel(value: DeliveryType): string {
  switch (value) {
    case DeliveryType.BG:
      return t('domain:shared.delivery_type.bg')
    case DeliveryType.JEPX:
      return t('domain:shared.delivery_type.jepx')
    case DeliveryType.EEX:
      return t('domain:shared.delivery_type.eex')
    default:
      return t('common:form.label.unspecified')
  }
}

export function convertDeliveryTypeToLabel(deliveryType: string): string {
  switch (deliveryType) {
    case DEAL_DELIVERY_TYPE.BG_BG:
      return t('domain:shared.delivery_type.bg_bg')
    case DEAL_DELIVERY_TYPE.BG_EEX:
      return t('domain:shared.delivery_type.bg_eex')
    case DEAL_DELIVERY_TYPE.JEPX_BG:
      return t('domain:shared.delivery_type.jepx_bg')
    case DEAL_DELIVERY_TYPE.JEPX_JEPX:
      return t('domain:shared.delivery_type.jepx_jepx')
    case DEAL_DELIVERY_TYPE.JEPX_EEX:
      return t('domain:shared.delivery_type.jepx_eex')
    case DEAL_DELIVERY_TYPE.EEX_BG:
      return t('domain:shared.delivery_type.eex_bg')
    case DEAL_DELIVERY_TYPE.EEX_JEPX:
      return t('domain:shared.delivery_type.eex_jepx')
    default:
      return t('common:form.label.unspecified')
  }
}

export function getIsPhysicalFutureByDeliveryType(
  deliveryType: string,
): boolean {
  switch (deliveryType) {
    case DEAL_DELIVERY_TYPE.BG_BG:
    case DEAL_DELIVERY_TYPE.JEPX_BG:
    case DEAL_DELIVERY_TYPE.JEPX_JEPX:
      return false
    case DEAL_DELIVERY_TYPE.EEX_BG:
    case DEAL_DELIVERY_TYPE.EEX_JEPX:
    case DEAL_DELIVERY_TYPE.BG_EEX:
    case DEAL_DELIVERY_TYPE.JEPX_EEX:
      return true
    default:
      return false
  }
}

export function getDeliveryTypeByDealPosition(
  deliveryType: string,
  dealPosition: DealPosition,
): DeliveryType {
  switch (dealPosition) {
    case DealPosition.BID:
      switch (deliveryType) {
        case DEAL_DELIVERY_TYPE.BG_BG:
        case DEAL_DELIVERY_TYPE.BG_EEX:
          return DeliveryType.BG
        case DEAL_DELIVERY_TYPE.JEPX_BG:
        case DEAL_DELIVERY_TYPE.JEPX_JEPX:
        case DEAL_DELIVERY_TYPE.JEPX_EEX:
          return DeliveryType.JEPX
        case DEAL_DELIVERY_TYPE.EEX_BG:
        case DEAL_DELIVERY_TYPE.EEX_JEPX:
          return DeliveryType.EEX
        default:
          return DeliveryType.UNSPECIFIED
      }
    case DealPosition.OFFER:
    case DealPosition.UNSPECIFIED:
    default:
      switch (deliveryType) {
        case DEAL_DELIVERY_TYPE.BG_BG:
        case DEAL_DELIVERY_TYPE.JEPX_BG:
        case DEAL_DELIVERY_TYPE.EEX_BG:
          return DeliveryType.BG
        case DEAL_DELIVERY_TYPE.JEPX_JEPX:
        case DEAL_DELIVERY_TYPE.EEX_JEPX:
          return DeliveryType.JEPX
        case DEAL_DELIVERY_TYPE.BG_EEX:
        case DEAL_DELIVERY_TYPE.JEPX_EEX:
          return DeliveryType.EEX
        default:
          return DeliveryType.UNSPECIFIED
      }
  }
}

export function getDeliveryTypeLabelByDealPosition(
  deliveryType: string,
  dealPosition: DealPosition,
): string {
  const calcDeliveryType = getDeliveryTypeByDealPosition(
    deliveryType,
    dealPosition,
  )

  return convertDeliveryTypeLabel(calcDeliveryType)
}

export function isFutureDeliveryType(deliveryType: DeliveryType): boolean {
  switch (deliveryType) {
    case DeliveryType.BG:
    case DeliveryType.JEPX:
      return false
    case DeliveryType.EEX:
      return true
    default:
      return false
  }
}
